// extracted by mini-css-extract-plugin
export default {"loadcontainer":"Home_loadcontainer__TkxYS"};